module.exports = __webpack_public_path__ + "/templates/pages/list[2020].twig";